(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  document.addEventListener('click', function(event) {
    document.querySelectorAll('.pcz-header__search-toggle[open]').forEach(function(details) {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.pcz-header__search-toggle[open]').forEach(function(details) {
      details.removeAttribute('open');
    });
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-copy-coupon]');
    if (!button) return;

    var text = button.getAttribute('data-copy-text') || '';
    var defaultLabel = button.getAttribute('data-copy-label-default') || 'Copiar cupom';
    var successLabel = button.getAttribute('data-copy-label-success') || 'Cupom copiado';

    if (!navigator.clipboard) return;

    navigator.clipboard.writeText(text).then(function() {
      button.textContent = successLabel;
      setTimeout(function() {
        button.textContent = defaultLabel;
      }, 1800);
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var drawer = document.getElementById('pcz-mobile-drawer');

    // Accordion exclusivo: abre um, fecha os outros
    document.addEventListener('click', function(event) {
      var summary = event.target.closest('.pcz-exclusive-accordion > summary');
      if (!summary) return;
      var clickedDetails = summary.parentElement;
      var allDetails = document.querySelectorAll('.pcz-exclusive-accordion');
      allDetails.forEach(function(details) {
        if (details !== clickedDetails && details.open) {
          details.open = false;
        }
      });
    });

    var body = document.body;
    var openButtons = document.querySelectorAll('[data-mobile-drawer-open]');
    var closeButtons = drawer.querySelectorAll('[data-mobile-drawer-close]');
    var panel = drawer.querySelector('.pcz-header__mobile-drawer-panel');
    var focusableSelector = 'a[href], button:not([disabled]), details summary, [tabindex]:not([tabindex="-1"])';
    var lastActiveElement = null;

    function setExpanded(value) {
      openButtons.forEach(function(button) {
        button.setAttribute('aria-expanded', value ? 'true' : 'false');
      });
    }

    function openDrawer() {
      lastActiveElement = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function() {
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('pcz-mobile-drawer-open');
      setExpanded(true);

      var firstFocusable = panel.querySelector(focusableSelector);
      if (firstFocusable) firstFocusable.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      body.classList.remove('pcz-mobile-drawer-open');
      setExpanded(false);

      window.setTimeout(function() {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, 280);

      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }

    openButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        openDrawer();
      });
    });

    closeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        closeDrawer();
      });
    });

    drawer.addEventListener('click', function(event) {
      if (event.target.closest('.pcz-header__mobile-link')) {
        closeDrawer();
      }
    });

    var mobileDirectLinks = document.querySelectorAll('[data-mobile-direct-link]');

    function navigateToDirectLink(event) {
      var link = event.currentTarget;
      var url = (link.getAttribute('data-mobile-direct-link') || link.getAttribute('href') || '').trim();
      if (!url || url === '#') return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(url);
    }

    mobileDirectLinks.forEach(function(link) {
      link.addEventListener('click', navigateToDirectLink);
      link.addEventListener('touchend', navigateToDirectLink, { passive: false });
    });

    document.addEventListener('keydown', function(event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }

      if (event.key === 'Tab') {
        var focusable = drawer.querySelectorAll(focusableSelector);
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-mobile-search-toggle]');
    if (!toggle) return;
    var panel = document.getElementById('pcz-mobile-search');
    if (!panel) return;
    var willOpen = panel.hasAttribute('hidden');
    panel.toggleAttribute('hidden', !willOpen);
    toggle.setAttribute('aria-expanded', String(willOpen));
    if (willOpen) {
      var input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');          
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              if(!sameCard) return;
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              if(!swiperContainer) return;
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
